import { getUser } from '@cast/infrastructure-auth';

const CLOSED_ALERTS_KEY = 'closedAlerts';

const getClosedAlerts = (): string[] => {
  const closedAlerts = localStorage.getItem(CLOSED_ALERTS_KEY);
  if (closedAlerts) {
    try {
      return JSON.parse(closedAlerts);
    } catch {
      console.error('Error parsing closed alerts from local storage');
      return [];
    }
  }
  return [];
};

const setClosedAlerts = (ids: string[]): void =>
  localStorage.setItem(CLOSED_ALERTS_KEY, JSON.stringify(ids));

export const addClosedAlert = (id: string): void => {
  const closedAlerts = getClosedAlerts();

  if (!closedAlerts.includes(id)) {
    closedAlerts.push(id);
    setClosedAlerts(closedAlerts);
  }
};

export const isAlertAlreadyClosed = (id: string): boolean =>
  getClosedAlerts().includes(id);

export const makePersonalizedAlertId = (id: string): string =>
  `${getUser()?.id}_${id}`;

export const isAlertDismissed = (id: string): boolean =>
  isAlertAlreadyClosed(makePersonalizedAlertId(id));
